import React, { useEffect, useRef } from "react";
import { useAlert } from "react-alert";
import { Prompt, useHistory, useLocation } from "react-router-dom";
import LeaderLine from "react-leader-line";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import useCheckMobileScreen from "../readingView/useCheckMobileScreen.jsx";
import auth from "../../../core/auth.js";
import { confirmAlert } from "react-confirm-alert";
import { manageRequest } from "../../../core/tools.js";
let CRC32 = require("crc-32");
const appparameters = require("../../../core/common.jsx");

export const Update = (props) => {
  const mac = mqtt_topics.choosenmac;
  const history = useHistory();
  const location = useLocation();
  const alert = useAlert();
  const leaderLinesRef = useRef({});
  let mobilescreen = useCheckMobileScreen();
  function handlesize(value) {
    return mobilescreen ? value / 2 : value;
  }
  let vectorSize = mobilescreen ? 2 : 4;
  const maxNumberOfFileSize = 2097152; //2 MB
  const defaulttextareamessage =
    "Choose or drag a file above to get firmware information ...";
  const [firmwareoutput, setfirmwareoutput] = useStateIfMounted(
    defaulttextareamessage
  );
  const [selectedfirmware, setselectedfirmware] = useStateIfMounted("");
  const [uploading, setuploading] = useStateIfMounted(0);
  const [uploadingProgress, setuploadingProgress] =
    useStateIfMounted("Uploading ...");
  const [downloadingProgress, setdownloadingProgress] =
    useStateIfMounted("Downloading ...");
  const [downloading, setdownloading] = useStateIfMounted(0);
  const [lastmqttmessagetime, setlastmqttmessagetime] = useStateIfMounted(0);
  let firmwareupgradetopic =
    mqtt_topics.fixed_topic_part + mac + mqtt_topics.firmwareupdate_topic;
  const [requestCheck, setRequestCheck] = useStateIfMounted(false);
  const [uploadedSoftwareVersion, setUploadedSoftwareVersion] =
    useStateIfMounted("");

  const Spacer = ({ size }) => (
    <div style={{ width: size, display: "inline-block" }}></div>
  );
  let firmwareupgradetimeout;
  /*const handleBeforeUnload = (event) => {
    const message =
      "Leaving this page will result in losing firmware upgrade progress. Are you sure?";
    event.returnValue = message; // Standard for most browsers
    return message; // For some older browsers
  };*/

  useEffect(() => {
    createAndUpdateVectors(
      "pc_icon",
      "server_icon",
      uploading == 1,
      "arrow",
      "right",
      "left",
      uploadingProgress,
      "",
      ""
    );
    createAndUpdateVectors(
      "server_icon",
      "surf_icon",
      downloading == 1,
      "grid",
      "right",
      "left",
      downloadingProgress,
      "",
      ""
    );
  }, [uploading, downloading, uploadingProgress, downloadingProgress]);

  const handleBeforeUnload = (event) => {
    const message =
      "Leaving this page will result in losing firmware upgrade progress. Are you sure?";
    event.returnValue = message; // Standard for most browsers
    return message; // For some older browsers
  };

  /*useEffect(() => {
    // Function to handle beforeunload event
    const handleBeforeUnload = (event) => {
      if (uploading === 1 || downloading === 1) {
        event.preventDefault();
        event.returnValue = ""; // Standard way to trigger the confirmation dialog
      }
    };

    // Function to handle navigation
    const handleNavigation = (event) => {
      if (uploading === 1 || downloading === 1) {
        event.preventDefault();
        event.returnValue = ""; // Standard way to trigger the confirmation dialog
      }
    };

    // Add beforeunload event listener
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Add event listener to handle navigation using history
    const unblock = history.block((location, action) => {
      if (uploading === 1 || downloading === 1) {
        if (action === "POP") {
          // 'POP' action refers to back/forward navigation
          return "You have unsaved changes. Are you sure you want to leave?";
        }
        // For other actions like PUSH (navigation via links), Prompt will handle
      }
      return true;
    });

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      unblock(); // Unblock navigation
    };
  }, [uploading, downloading, history]);*/

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (uploading === 1 || downloading === 1) {
        const confirmLeave = window.confirm(
          "Leaving this page will result in losing firmware upgrade progress. Are you sure?"
        );

        if (confirmLeave) {
          // ✅ Run your custom cleanup code here
          resetupdatediagram();
          manageRequest(
            "delete",
            "Firmware Upgrade",
            localStorage.getItem("token"),
            localStorage.getItem("username"),
            mqtt_topics.choosenmac
          );

          // unblock navigation so it can proceed
          unblock(); // important: remove the block

          // return true to allow the navigation
          return true;
        } else {
          // return false to block navigation
          return false;
        }
      }
      // no uploads/downloads in progress → allow navigation
      return true;
    });

    return () => unblock();
  }, [uploading, downloading, history]);

  //when componenet unmount
  useEffect(
    () => () => {
      resetupdatediagram();
      if (leaderLinesRef.current["pc_icon_server_icon"] != undefined) {
        leaderLinesRef.current["pc_icon_server_icon"].remove();
      }
      if (leaderLinesRef.current["server_icon_surf_icon"] != undefined) {
        leaderLinesRef.current["server_icon_surf_icon"].remove();
      }
      location.mqttClient.unsubscribe(firmwareupgradetopic);
      location.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  useEffect(() => {
    firmwareupgradetimeout = setInterval(() => {
      keepcheckforfirmwareupgradetimeout();
    }, 5 * 1000);

    return () => clearInterval(firmwareupgradetimeout);
  }, [downloading, lastmqttmessagetime]);

  const updateoptions = {
    customUI: ({ onClose }) => {
      return (
        <div className="alert">
          <h1 className="alert__title">Firmware Upgrade Confirmation</h1>
          <p className="alert__body">
            Are you sure you want to proceed with updating the firmware for{" "}
            {mqtt_topics.choosenid}?
          </p>
          <button
            onClick={() => {
              if (
                localStorage.getItem("sv_of_" + mac) == uploadedSoftwareVersion
              ) {
                startupload();
                onClose();
              } else {
                confirmAlert(firmwarecompatibleoptions);
              }
            }}
            className="btn btn-primary"
          >
            Proceed
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      );
    },
  };

  const firmwarecompatibleoptions = {
    customUI: ({ onClose }) => {
      return (
        <div className="alert">
          <h1 className="alert__title">
            Firmware Upgrade Compatibility Confirmation
          </h1>
          <p className="alert__body">
            The chosen firmware is not compatible with your device's firmware.
            Proceeding with this warning may cause your device to go offline or
            overwrite your parameters. Are you sure you want to proceed with
            updating the firmware for {mqtt_topics.choosenid}?
          </p>
          <button
            onClick={() => {
              startupload();
              onClose();
            }}
            className="btn btn-primary"
          >
            Proceed
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      );
    },
  };

  function keepcheckforfirmwareupgradetimeout() {
    if (downloading == 1 || uploading == 2) {
      if (new Date().getTime() - lastmqttmessagetime > 240 * 1000) {
        //4 mins delay
        resetupdatediagram();
        manageRequest(
          "delete",
          "Firmware Upgrade",
          localStorage.getItem("token"),
          localStorage.getItem("username"),
          mqtt_topics.choosenmac
        );
        alert.show(
          "Firmware upgrade failed; the timeout was reached. Please retry.",
          { type: "error", timeout: 0, position: "middle" }
        );
        clearInterval(firmwareupgradetimeout);
      }
    }
  }

  function getoutdownloadprogressfromsurf() {
    location.mqttClient.subscribe(firmwareupgradetopic);
    location.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == firmwareupgradetopic) {
      setlastmqttmessagetime(new Date().getTime());
      message = JSON.parse(message.toString());
      //console.log(message);
      if (Number(message.FirmwareUpgradeResult) == 255) {
        //inprogress
        setdownloading(1);
        if (Number(message.UpgradingStarted) == 0) {
          setdownloadingProgress(
            `Download Progress: ${Number(message.FileDnloadProgress)}%`
          );
        } else {
          setdownloadingProgress(`Installing Firmware ...`);
        }
      } else {
        if (Number(message.FirmwareUpgradeResult) == 1) {
          //succeded
          setdownloading(2);
          alert.show("Firmware upgrade was successful.", {
            type: "success",
            timeout: 0,
            position: "middle",
          });
        } else if (Number(message.FirmwareUpgradeResult) == 2) {
          //abort
          setdownloading(0);
          alert.show("Firmware upgrade aborted.", {
            type: "info",
            timeout: 0,
            position: "middle",
          });
        } else {
          //failed
          setdownloading(0);
          alert.show("Firmware upgrade failed.", {
            type: "error",
            timeout: 0,
            position: "middle",
          });
        }
        location.mqttClient.unsubscribe(firmwareupgradetopic);
        location.mqttClient.removeListener("message", handleMqttMessage);
        manageRequest(
          "delete",
          "Firmware Upgrade",
          localStorage.getItem("token"),
          localStorage.getItem("username"),
          mqtt_topics.choosenmac
        );
      }
    }
  }

  async function checkAndExtractSASInfo(e) {
    resetupdatediagram();
    //console.log(e.target.files[0]);
    let targetfile = e.target.files[0];
    if (
      targetfile != undefined &&
      targetfile.name.toLowerCase().includes(".sas")
    ) {
      //check file size
      if (targetfile.size < maxNumberOfFileSize) {
        let byteFile = await getAsByteArray(targetfile);
        let filelen = byteFile.length;
        //checksum
        let crc_file_sum =
          CRC32.buf(byteFile.slice(0, filelen - 4)) ^ 0xffffffff;
        let crc_local_sum =
          (byteFile[filelen - 1] << 24) |
          (byteFile[filelen - 2] << 16) |
          (byteFile[filelen - 3] << 8) |
          byteFile[filelen - 4];
        if (crc_file_sum == crc_local_sum) {
          let revision_number =
            byteFile[filelen - 10] + (byteFile[filelen - 9] << 8);
          let software_version =
            byteFile[filelen - 14] + (byteFile[filelen - 13] << 8);
          setUploadedSoftwareVersion(software_version);
          let device_type = byteFile[filelen - 15];
          let sas_device = byteFile[filelen - 16];
          let firmware_description = "";
          let firmware_description_index = 22;
          let firmware_description_maxLength = 255;
          for (
            let i = firmware_description_index;
            i < firmware_description_index + firmware_description_maxLength;
            i++
          ) {
            if (byteFile[i] == 0) {
              break;
            }
            firmware_description += String.fromCharCode(parseInt(byteFile[i]));
          }
          setfirmwareoutput(
            "Firmware Description: " +
              firmware_description +
              "\nSAS firmware verification: Valid" +
              "\nFirmware file size: " +
              ((targetfile.size / 1024).toFixed(2) + "KB") +
              "\nFirmware version: " +
              software_version +
              "\nFirmware revision: " +
              revision_number
          ); //"\nFirmware lastmodified: " + targetfile.lastModifiedDate+
          setselectedfirmware(targetfile);
          return;
        } else {
          //failed check crc sum
          alert.show("Corrupted file.", { type: "error", position: "middle" });
        }
      } else {
        //file size exceed the limit
        alert.show("Not supported file size.", {
          type: "error",
          position: "middle",
        });
      }
    } else {
      //wrong file format
      alert.show("Not supported file format.", {
        type: "error",
        position: "middle",
      });
    }
    e.target.value = null;
    setfirmwareoutput(defaulttextareamessage);
  }

  async function getAsByteArray(file) {
    return new Uint8Array(await readFile(file));
  }

  function readFile(file) {
    return new Promise((resolve, reject) => {
      // Create file reader
      let reader = new FileReader();

      // Register event listeners
      reader.addEventListener("loadend", (e) => resolve(e.target.result));
      reader.addEventListener("error", reject);

      // Read file
      reader.readAsArrayBuffer(file);
    });
  }

  const startupload = async () => {
    // if (localStorage.getItem("sv") == uploadedSoftwareVersion) {
    setRequestCheck(true);
    if (
      await manageRequest(
        "check",
        "Firmware Upgrade",
        localStorage.getItem("token"),
        localStorage.getItem("username"),
        mqtt_topics.choosenmac
      )
    ) {
      setRequestCheck(false);
      manageRequest(
        "add",
        "Firmware Upgrade",
        localStorage.getItem("token"),
        localStorage.getItem("username"),
        mqtt_topics.choosenmac
      );
      //start
      if (
        selectedfirmware != "" &&
        selectedfirmware != undefined &&
        selectedfirmware != null
      ) {
        setuploading(1);
        let data = new FormData();
        data.append("userdata", JSON.stringify(auth.getUserData()));
        data.append("tag", mac);
        data.append("file", selectedfirmware);

        const xhr = new XMLHttpRequest();

        // Listen for upload progress
        xhr.upload.addEventListener("progress", function (event) {
          if (event.lengthComputable) {
            const percentage = (event.loaded / event.total) * 100;
            //console.log(`Upload Progress: ${Math.round(percentage)}%`);
            setuploadingProgress(`Upload Progress: ${Math.round(percentage)}%`);
          }
        });
        xhr.open(
          "POST",
          appparameters.backend_app_url + "/frontend/uploadSASFirmware"
        );
        xhr.onload = function () {
          if (xhr.status === 200) {
            //console.log('Request successful', xhr.responseText);
            if (JSON.parse(xhr.responseText).path != undefined) {
              setuploadingProgress("Uploaded successful");
              setuploading(2);
              setlastmqttmessagetime(new Date().getTime());
              requestfirmwareupgrade(JSON.parse(xhr.responseText).path);
              getoutdownloadprogressfromsurf();
            } else {
              alert.show("Failed to upload file.", {
                type: "error",
                timeout: 0,
                position: "middle",
              });
              setuploading(0);
              manageRequest(
                "delete",
                "Firmware Upgrade",
                localStorage.getItem("token"),
                localStorage.getItem("username"),
                mqtt_topics.choosenmac
              );
            }
          } else {
            alert.show("Failed to upload file.", {
              type: "error",
              timeout: 0,
              position: "middle",
            });
            setuploading(0);
            manageRequest(
              "delete",
              "Firmware Upgrade",
              localStorage.getItem("token"),
              localStorage.getItem("username"),
              mqtt_topics.choosenmac
            );
          }
        };
        xhr.onerror = function () {
          //console.log('Request failed');
          setuploading(0);
          alert.show("Failed to upload file.", {
            type: "error",
            timeout: 0,
            position: "middle",
          });
          manageRequest(
            "delete",
            "Firmware Upgrade",
            localStorage.getItem("token"),
            localStorage.getItem("username"),
            mqtt_topics.choosenmac
          );
        };
        xhr.send(data);
      } else {
        alert.show("Browse a file to start the upgrade.", {
          type: "error",
          position: "middle",
        });
        manageRequest(
          "delete",
          "Firmware Upgrade",
          localStorage.getItem("token"),
          localStorage.getItem("username"),
          mqtt_topics.choosenmac
        );
      }
    } else {
      alert.show(
        mqtt_topics.choosenid + " is busy right now. Please try again later.",
        {
          type: "info",
          position: "middle",
        }
      );
    }
    /*} else {
      setuploading(0);
      alert.show(
        "The chosen firmware is not compatible with your device's firmware. Contact support for more information.",
        { type: "error", timeout: 0 }
      );
    }*/
  };

  function requestfirmwareupgrade(dir) {
    location.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.parse(
        JSON.stringify(
          '{ "action": "Firmware Upgrade","directory":"' + dir + '" }'
        )
      )
    );
  }

  function createAndUpdateVectors(
    from,
    to,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    offset,
    startSocketGravity
  ) {
    let startcolor = "deepskyblue";
    let endclor = "gold";
    if (
      document.getElementById(from) != undefined &&
      document.getElementById(to) != undefined
    ) {
      let target = from + "_" + to;
      let oppositTarget = to + "_" + from;
      if (onload) {
        let options = {
          startPlugColor: startcolor,
          endPlugColor: endclor,
          gradient: true,
          dash: { animation: true },
          path: path,
          startSocket: startSocket,
          endSocket: endSocket,
          //endPlugSize: vectorEndPlugSize,
          size: vectorSize,
          startLabel: LeaderLine.captionLabel(startLabel, {
            color: startcolor,
            fontSize: mobilescreen ? "0.450em" : "0.750em",
          }),
          middleLabel: middleLabel,
          endLabel: LeaderLine.captionLabel(endLabel, {
            color: endclor,
            offset: offset,
          }),
          startSocketGravity: startSocketGravity,
          endPlug: "behind",
        };

        if (leaderLinesRef.current[target] != undefined) {
          try {
            leaderLinesRef.current[target].setOptions(options);
          } catch (Exception) {
            leaderLinesRef.current[target] = new LeaderLine(
              document.getElementById(from),
              document.getElementById(to),
              options
            );
            //check the opposit if found delete
            if (leaderLinesRef.current[oppositTarget] != undefined) {
              leaderLinesRef.current[oppositTarget].remove();
              delete leaderLinesRef.current[oppositTarget];
            }
          }
        } else {
          leaderLinesRef.current[target] = new LeaderLine(
            document.getElementById(from),
            document.getElementById(to),
            options
          );
          //check the opposit if found delete
          if (leaderLinesRef.current[oppositTarget] != undefined) {
            leaderLinesRef.current[oppositTarget].remove();
            delete leaderLinesRef.current[oppositTarget];
          }
        }
      } else {
        if (leaderLinesRef.current[target] != undefined) {
          try {
            leaderLinesRef.current[target].remove();
            delete leaderLinesRef.current[target];
          } catch (Exception) {}
        }
      }
    }
  }
  function resetupdatediagram() {
    setRequestCheck(false);
    setuploading(0);
    setdownloading(0);
    setdownloadingProgress("Downloading ...");
    setuploadingProgress("Uploading ...");
    window.removeEventListener("beforeunload", handleBeforeUnload);
  }
  const abortlogoptions = {
    customUI: ({ onClose }) => {
      return (
        <div className="alert">
          <h1 className="alert__title">Abort Log Retrieval Confirmation</h1>
          <p className="alert__body">
            Are you sure you want to abort the firmware upgrade for{" "}
            {mqtt_topics.choosenid}?
          </p>
          <button
            onClick={() => {
              location.mqttClient.publish(
                mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
                JSON.parse(
                  JSON.stringify('{ "action": "Abort Firmware Upgrade" }')
                )
              );
              resetupdatediagram();
              manageRequest(
                "delete",
                "Firmware Upgrade",
                localStorage.getItem("token"),
                localStorage.getItem("username"),
                mqtt_topics.choosenmac
              );
              onClose();
            }}
            className="btn btn-primary"
          >
            Proceed
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      );
    },
  };
  //firmwareupgradepage
  return (
    <div>
      <div className="container">
        <div className="row loginrow">
          <div className="col">
            <div className=" d-flex justify-content-start align-items-center position-relative text-white">
              <button
                type="button"
                onClick={() => window.history.back()}
                className="close text-white"
                title="Back"
                style={{ zIndex: 1 }}
              >
                &#x3c;&#x3c;
              </button>
              <div className="text-center w-100">
                <strong>Firmware Upgrade Page</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container  text-center">
        <div className="row  ">
          <div className="col">
            <img
              id="pc_icon"
              src={require("./../../../images/firmwareupgrade/computer.png")}
              style={{
                height: handlesize(80) + "px",
                width: handlesize(60) + "px",
              }}
            />
          </div>
          {uploading == 2 && (
            <div>
              <img
                src={require("./../../../images/firmwareupgrade/done.png")}
                style={{
                  height: handlesize(50) + "px",
                  width: handlesize(50) + "px",
                }}
              />
            </div>
          )}

          <div className="col">
            <img
              id="server_icon"
              src={require("./../../../images/firmwareupgrade/cloud_server.png")}
              style={{
                height: handlesize(80) + "px",
                width: handlesize(65) + "px",
              }}
            />
          </div>
          {downloading == 2 && (
            <div>
              <img
                src={require("./../../../images/firmwareupgrade/done.png")}
                style={{
                  height: handlesize(50) + "px",
                  width: handlesize(50) + "px",
                }}
              />
            </div>
          )}
          <div className="col">
            <img
              id="surf_icon"
              src={require("./../../../images/surflogoo.png")}
              style={{
                height: handlesize(80) + "px",
                width: handlesize(80) + "px",
              }}
            />
            <br></br>
            {mqtt_topics.choosenid}
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col">
            <div className="form-group">
              <input
                type="file"
                className="form-control-file"
                id="exampleFormControlFile1"
                accept=".sas"
                onChange={checkAndExtractSASInfo}
                disabled={uploading == 1 || downloading == 1}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <textarea
                type="text"
                className="firmwaredescription"
                id="firmwaredescription"
                rows="7"
                cols="6"
                placeholder="Selected Firmware Description."
                disabled={true}
                value={firmwareoutput}
              />
            </div>
          </div>
        </div>
        <button
          className="btn btn-info"
          onClick={() => confirmAlert(updateoptions)}
          disabled={uploading == 1 || downloading == 1}
          style={{ visibility: requestCheck ? "hidden" : "visible" }}
        >
          Start Upgrade
        </button>
        <div
          className="spinner-border text-primary"
          style={{ visibility: !requestCheck ? "hidden" : "visible" }}
        ></div>
        <Spacer size={requestCheck ? "60px" : "30px"} />
        <button
          className="btn btn-info"
          onClick={() => confirmAlert(abortlogoptions)}
          disabled={uploading != 1 && downloading != 1}
        >
          Abort
        </button>

        <br />
        <br />
        <hr></hr>
        <center>
          Don't navigate back, refresh, or close the page once the upgrade has
          started. Doing so will result in the loss of both progress and
          results, and you won't be able to return.
          <br />
          The upgrade process will forcefully shut down your generator if it is
          running.
          <br />
          The upgrade process will take approximately 5 minutes to complete.
          <br />
          Please be patient.
        </center>
      </div>
    </div>
  );
};
